var map = {
	"./brandbil.png": 7116,
	"./filur.png": 8748,
	"./gintonic.png": 9278,
	"./gintonic2.png": 4553,
	"./isbjoern.png": 8127,
	"./pinacolada.png": 8818,
	"./schiefwasser.png": 1231,
	"./schiwasser.png": 4167,
	"./sexonthebeach.png": 5613,
	"./shots.png": 7085,
	"./tequilasunrise.png": 7733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;